module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/fork-spoon-knife-d1fed2fd6df4c480903cb645eef528ec.svg";